__webpack_require__.p = "${SP_STATIC_PATH_WITHOUT_TRAILING_SLASH}";